import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import ScrollLock from 'react-scrolllock';
import shortid from 'shortid';
import Panel from '../Panel';
import Modal from '../Modal';
import styles from './styles.module.scss';

export default class Dialog extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.node),
    children: PropTypes.node,
  };

  static defaultProps = {
    title: undefined,
    actions: [],
    children: null,
  };

  body = null;

  bodyRef = ref => {
    this.body = ref;
  };

  renderTitle() {
    const { title } = this.props;

    return title && <h2 className={styles['title']}>{title}</h2>;
  }

  renderActions() {
    const { actions } = this.props;

    if (isEmpty(actions)) {
      return null;
    }

    return (
      <div className={styles['actions']}>
        {actions.map(action =>
          React.cloneElement(action, {
            key: shortid.generate(),
          })
        )}
      </div>
    );
  }

  renderBody() {
    const { children } = this.props;

    return children && <div className={styles['body']}>{children}</div>;
  }

  render() {
    const { title, actions, children, ...props } = this.props;

    return (
      <Modal {...props}>
        <ScrollLock touchScrollTarget={this.body} />
        <Panel shadowSize="xl">
          {this.renderTitle()}
          {this.renderBody()}
          {this.renderActions()}
        </Panel>
      </Modal>
    );
  }
}
